import {
  SITE_STORE_URL,
  SITE_PRODUCTION_URL,
  SITE_INTERNAL_URL,
  SITE_PREPARATION_URL,
  SITE_UK_STORE_URL
} from '../constants/global';

const parseURL = (url: string): URL | null => {
  try {
    return new URL(url);
  } catch (error) {
    console.error('Invalid URL:', error);
    return null;
  }
};

export const getURLPathname = (url: string) => {
  const parsedURL = parseURL(url);
  return parsedURL ? parsedURL.pathname : '#';
};

export const getUrlHash = (url: string) => {
  const parsedURL = parseURL(url);
  return parsedURL ? parsedURL.hash : '#';
};

export const formatUrl = (url = '#', replace_store = false) => {
  let newUrl = url || '#';
  const list = [SITE_PRODUCTION_URL, SITE_INTERNAL_URL, SITE_PREPARATION_URL, SITE_UK_STORE_URL, SITE_STORE_URL];
  if (url.includes(SITE_STORE_URL) && replace_store) {
    return '/stores';
  }

  if (url.includes(SITE_UK_STORE_URL)) {
    newUrl = url.replace('/en-us', '');
  }
  list.forEach((item) => {
    if (newUrl.includes(item)) {
      newUrl = getURLPathname(newUrl);
    }
  });

  return newUrl;
};
